export enum emailChangeTypes {
  FETCH_EMAIL_CHANGE_REQUEST = "FETCH_EMAIL_CHANGE_REQUEST",
  FETCH_EMAIL_CHANGE_SUCCESS = "FETCH_EMAIL_CHANGE_SUCCESS",
  FETCH_EMAIL_CHANGE_FAILURE = "FETCH_EMAIL_CHANGE_FAILURE",
}